import type { Result } from "@bridepath/shared";
import { appError, err, ok } from "@bridepath/shared";

const base = (): string =>
  (window as unknown as { __BRIDEPATH_API__?: string }).__BRIDEPATH_API__ ?? "";

export const apiGet = async <T>(path: string, token: string): Promise<Result<T>> => {
  try {
    const res = await fetch(`${base()}${path}`, {
      headers: { authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      const body = await res.text().catch(() => "");
      return err(appError("UPSTREAM_FAILED", `api ${res.status}: ${body.slice(0, 256)}`));
    }
    const json = (await res.json()) as T;
    return ok(json);
  } catch (e) {
    return err(appError("UPSTREAM_FAILED", "api unreachable", { cause: e, retriable: true }));
  }
};

export const apiPost = async <T>(
  path: string,
  token: string,
  body: unknown,
): Promise<Result<T>> => {
  try {
    const res = await fetch(`${base()}${path}`, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "content-type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      return err(appError("UPSTREAM_FAILED", `api ${res.status}: ${text.slice(0, 256)}`));
    }
    return ok((await res.json()) as T);
  } catch (e) {
    return err(appError("UPSTREAM_FAILED", "api unreachable", { cause: e, retriable: true }));
  }
};
